import { NavLink } from 'react-router-dom';
import { useQuery } from 'react-query';
import { Icon } from '@mui/material';
import { getStudyById } from '../api/studiesAPI';
import { useParams } from 'react-router-dom';
import { useContext } from 'react';
import BillingGrid from '../components/billing-grid/BillingGrid';
import StudyStatusAlerts from '../components/ui/StudyStatusAlerts';
import AuthContext from '../store/auth-context';
import Loader from '../components/ui/Loader';
import Button from '../components/ui/Button';

import './BillingGridPage.scss';
import BillingGridTour from '../components/ui/BillingGridTour';

const BillingGridPage = () => {
	const { studyId } = useParams();
	const authCtx = useContext(AuthContext);

	const {
		isLoading,
		isError,
		error,
		data: studyData
	} = useQuery({
		queryKey: ['study', studyId],
		queryFn: () => getStudyById(studyId),
		retry: false,
		staleTime: 3000000 //5 minutes to refetch
	});

	if (!studyData) {
		return <Loader centered></Loader>;
	}

	const { study } = studyData.data;

	let pageContent = null;

	if (isLoading) {
		pageContent = <Loader centered></Loader>;
	} else if (isError) {
		pageContent = (
			<div>Error fetching post: {error.message}</div>
		);
	} else {
		return (
			<>
				<BillingGridTour status={study.status} />
				<div className='billing-grid-container'>
					<div className='billing-grid-title-container'>
						<NavLink to={`/dashboard/${study._id}`}>
							<Button className='secondary-button'>
								<Icon>chevron_left</Icon>
							</Button>
						</NavLink>

						<div className='billing-grid-title'>
							<h2>{study.title}</h2>
						</div>
					</div>
					<div>
						<StudyStatusAlerts
							type={study.type}
							status={study.status}
							issue={study.issue}
						/>
					</div>
					<div className='billing-gird-tables'>
						<h4>Billing Grid</h4>
						<div className='billing-grid-acronyms'>
							<h6>Acronyms:</h6>
							<p>
								{`"${authCtx.userData.s}"`} - Covered by
								Research / Study
							</p>
							<p>
								{`"${authCtx.userData.n}"`} - Covered by
								Insurance
							</p>
							<p>
								{`"${authCtx.userData.nb}"`} - Non-billable
							</p>
						</div>
						{study.status === 'ONE' &&
						authCtx.userData.role === 'PI' ? (
							<p>Billing grid under Q.A.M revision...</p>
						) : (
							<div>
								<BillingGrid
									studyId={study._id}
									billingGridData={study.billingGrid}
									studyStatus={study.status}
								/>
							</div>
						)}
					</div>
				</div>
			</>
		);
	}
};

export default BillingGridPage;
